import { Outlet } from 'react-router-dom';
import Footer from './Pages/Layouts/Footer';
import Header from './Pages/Layouts/Header';

const Layout = () => {
    return (
        <>
            <Header />
            <Outlet />
            <Footer />
        </>
    );
};

export default Layout;  